import DS from 'ember-data';
import Route from 'cio/routes/base';
import { inject as service } from '@ember/service';
import Transition from '@ember/routing/-private/transition';
import AlertsService from 'cio/services/alerts';
import IntegrationsReportingWebhooksEditController from 'cio/pods/integrations/reporting-webhooks/edit/controller';
import WebhookModel from 'cio/models/webhook';
import ConfirmChangesService from 'cio/services/confirm-changes';

export default class IntegrationsReportingWebhooksEdit extends Route {
  @service alerts!: AlertsService;
  @service store!: DS.Store;
  @service confirmChanges!: ConfirmChangesService;

  crumb() {
    return {
      name: 'Edit Webhook',
      path: 'integrations.reporting-webhooks.edit',
    };
  }

  model(params: { webhook_id: string }) {
    return this.store.findRecord('webhook', params.webhook_id);
  }

  setupController(
    controller: IntegrationsReportingWebhooksEditController,
    model: WebhookModel,
    transition: Transition,
  ) {
    super.setupController(controller, model, transition);

    controller.fetchWebhooks.perform();

    this.confirmChanges.register(controller, this);
  }

  resetController(controller: IntegrationsReportingWebhooksEditController, isExiting: boolean, transition: Transition) {
    super.resetController(controller, isExiting, transition);

    if (isExiting) {
      controller.model.rollbackAttributes();
    }
  }
}
